import React from 'react';
const PhrasesGuide: React.FC = () => (
  <div className="min-h-screen bg-white py-12" dir="ltr">
    <div className="max-w-3xl mx-auto bg-pink-50 rounded-xl shadow-lg p-8">
      <h1 className="text-3xl font-bold text-pink-900 mb-6">Emotional & Fun Phrases in Persian</h1>
      <p className="text-lg text-gray-700 mb-4">Express your feelings, make friends, and use Persian slang with confidence.</p>
      {/* Add more content here */}
    </div>
  </div>
);
export default PhrasesGuide; 